import { render } from "./LeaveType.vue?vue&type=template&id=c2cb61e4"
import script from "./LeaveType.vue?vue&type=script&lang=js"
export * from "./LeaveType.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__